import { Disjoint } from "../shared/disjoint.js";
import { implementNode } from "../shared/implement.js";
import { BaseRange, parseDateLimit, parseExclusiveKey } from "./range.js";
export const beforeImplementation = implementNode({
    kind: "before",
    collapsibleKey: "rule",
    hasAssociatedError: true,
    keys: {
        rule: {
            parse: parseDateLimit,
            serialize: schema => schema.toISOString()
        },
        exclusive: parseExclusiveKey
    },
    normalize: schema => (typeof schema === "number" ||
        typeof schema === "string" ||
        schema instanceof Date) ?
        { rule: schema }
        : schema,
    defaults: {
        description: node => node.exclusive ?
            `before ${node.stringLimit}`
            : `${node.stringLimit} or earlier`,
        actual: data => data.toLocaleString()
    },
    intersections: {
        before: (l, r) => (l.isStricterThan(r) ? l : r),
        after: (before, after, ctx) => before.overlapsRange(after) ?
            before.overlapIsUnit(after) ?
                ctx.$.node("unit", { unit: before.rule })
                : null
            : Disjoint.from("range", before, after)
    }
});
export class BeforeNode extends BaseRange {
    traverseAllows = this.exclusive ? data => data < this.rule : data => data <= this.rule;
    impliedBasis = this.$.keywords.Date.raw;
}
